import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { htmlEncode } from '../../../utils/escape.utils';
import { TimelineItemWebComponent } from '../../timelineItem';

export class TimelineGroupView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.timeline-container');
    this.dom.$viewOnGraph = this.shadow.querySelector('#viewOnGraph');
  }

  buildView(data: any) {
    if (!data || !data.response || !data.response.length) {
      this.dom.$viewOnGraph.classList.add('hidden');
      // the gz-text class was added for automated tests
      this.dom.$wrapper.innerHTML =
        '<gz-image-repo>' +
        '<gz-text fontSize="16" fontWeight="500" class="highlights-empty">Highlights could not be generated.</gz-text>' +
        '</gz-image-repo>';
      return;
    }

    this.dom.$viewOnGraph.innerHTML = htmlEncode(this.dependencies.translateFn('view in graph'));

    for (const alert of data.response) {
      const component = new TimelineItemWebComponent();
      component.alertTitle = alert.name;
      component.killChainPhases = alert.tactic;
      component.severity = alert.severity;
      component.alertDescription = alert.description;
      component.sensor = alert.sensor;
      component.identicalTactic = alert.identicalTactic;
      component.numberOfEndpoints = alert.numberOfEndpoints;
      component.numberOfServers = alert.numberOfServers;
      component.numberOfInternalEmails = alert.numberOfInternalEmails;
      component.numberOfIps = alert.numberOfIps;
      component.numberOfIdentities = alert.numberOfIdentities;

      component.injectDependencies(this.dependencies);
      component.start().then().catch();
      this.dom.$wrapper.append(component);
    }
  }
}
